import { apiGetCustomers } from "@lib/api/customer";
import { CustomerName } from "@lib/components/MiniComponents/Others";
import { useQuery } from "@tanstack/react-query";
import { Select } from "antd";
import { useTypedSelector, useTypedDispatch } from "@lib/redux";
import { setSelectedCustomer } from "@lib/redux/slices/cache";
import { FormattedMessage } from "react-intl";

type Props = {
  style?: React.CSSProperties;
};

export default function SelectedCustomerSelectBox({ style }: Props) {
  const dispatch = useTypedDispatch();
  const { selectedCustomer } = useTypedSelector((state) => state.cache);

  const { data } = useQuery({
    queryKey: ["customers-dropdown"],
    queryFn: () =>
      apiGetCustomers({
        sort: "name,ASC",
        limit: 100,
      }),
  });
  const apiData = data?.data?.data;

  return (
    <Select
      value={selectedCustomer?.id || "all"}
      onChange={(value) => {
        dispatch(
          setSelectedCustomer(apiData?.find((item) => item.id === value)),
        );
      }}
      showSearch
      style={{ width: "100%", ...style }}
      filterOption={(input, option) =>
        option?.text?.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      options={[
        {
          label: <FormattedMessage id="common.all" />,
          text: "All",
          value: "all",
        },
        ...(apiData?.map((item) => ({
          label: <CustomerName customer={item} titleMaxLength={20} />,
          text: item.name,
          value: item.id,
        })) || []),
      ]}
    />
  );
}
